import { render, staticRenderFns } from "./non-available.vue?vue&type=template&id=246a7ace&scoped=true&"
import script from "./non-available.vue?vue&type=script&lang=js&"
export * from "./non-available.vue?vue&type=script&lang=js&"
import style0 from "./non-available.vue?vue&type=style&index=0&id=246a7ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a7ace",
  null
  
)

export default component.exports